import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AccountFeatureToggle } from 'src/app/model/account-feature-toggles.model';
import { commonState_SystemConfig_LimitedServiceToggles } from 'src/app/store/common/common.selectors';
import { FeatureToggleName } from 'src/app/model/feature-toggle-name.model';
import { AsyncPipe, NgIf } from '@angular/common';
import { AnimateCssDirective } from 'src/app/modules/shared/directives/animatecss.directive';
import { TenantConfigPipe } from 'src/app/modules/shared/pipes/tenantconfig';
import { environment } from '../../../environments/environment';
import { DateHelper } from 'src/app/helper/dateHelper';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  styleUrls: ['./maintenance-page.component.scss'],
  imports: [AnimateCssDirective, AsyncPipe, TenantConfigPipe, NgIf],
})
export class MaintenancePageComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  limitedServiceToggles$ = this.store.pipe(
    select(commonState_SystemConfig_LimitedServiceToggles)
  );
  toggle: AccountFeatureToggle = null;
  animateContentWrapper = environment.views.loginView.animateContentWrapper;
  animateWrapper = environment.views.loginView.animateWrapper;
  dateHelper: DateHelper = new DateHelper();

  constructor(public store: Store<AppState>, private router: Router) {
    super();

    this.sub = this.limitedServiceToggles$.subscribe(
      (limitedServiceToggles) => {
        if (!limitedServiceToggles) {
          this.router.navigate(['/']);
        } else {
          // Should always have the blackout toggle when we get to this page due to account guard
          var siteBlackoutToggle = limitedServiceToggles.find(
            (o) => o.name === FeatureToggleName.member.maintenance.view
          );

          const date = this.dateHelper.convertToSydneyTime(new Date());

          if (
            this.dateHelper.convertToSydneyTime(new Date(siteBlackoutToggle.startDate)) <=
              date &&
            date <=
              this.dateHelper.convertToSydneyTime(new Date(siteBlackoutToggle.endDate))
          ) {
            this.toggle = siteBlackoutToggle;
          } else {
            // Redirect to dashboard as we dont want users going to this page manually
            this.router.navigate(['/']);
          }
        }
      }
    );
  }

  ngOnInit() {
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }
}
